/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type StockStatus = typeof StockStatus[keyof typeof StockStatus];


export const StockStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
